var querystring = require('querystring-es3');
var ClientModel = require('./models/client');
var cookieHelper =  require('./shared/cookie-helper');
var getAdditionForTitle = require("./shared/title");

var App = function() {
  this.initialized = false;
  this.lastSelectedStore = null;
};

App.prototype = {

  initialized: false,
  checkRedirect: true,

  /**
   * Should be overridden by every entry point implementation with the actual routes. If
   * it has access restrictions for any view, should implement a 'login' route.
   */
  routes: {},

  /**
   * Should be overridden by every entry point implementation with the routes that require permission
   * for access. Each property should have the name of the route and the value should be null if no other
   * other restrictions apply, or the name of the url parameter over which the restriction is applied.
   */
  routePermissions: {},

  lastSelectedStore: null,

  noteSelectedStore: function(store) {
    if (store != null) {
      this.lastSelectedStore = store;
    }
  },

  init: function() {
    console.log("Init");
    if (this.initialized)
      return;

    this.initialized = true;
    this.pageRendered = false;

    Backbone.Layout.configure({
      manage: true,
      useRAF: true, //Enable or disable async rendering
      el: false,
      fetchTemplate: function(templateName) {
        console.log('Getting template: ' + templateName);
        return bookedby.templates[templateName];
      },
      renderTemplate: function(template, context) {
        console.log('Rendering template...');

        var currentClientJson = bookedby.app.getCurrentClientJson();
        setTimeout(function(){
          if($('.js-menu-link[data-href="start-booking"]').hasClass('is-active')){
              if ($(".js-toggle__has-store").css('display') === 'none' || $(".js-action__find-appointment").length <= 0) {
                  $(".js-focus-location").focus();
              }
          } else if (bookedby.app.currentPath === "stores-list") {
            $(".js-focus-location").focus();
          }else {
              $(".js-menu-button").focus();
          }
        },0);
        return template(context, currentClientJson, bookedby.helpers);
      }
    });

    bookedby.staticData.storeGroupSettings = bookedby.staticData.storeGroupSettings || {};

    // decode custom top bar navigation items
    if (bookedby.staticData.storeGroupSettings.topBarNavigationContent) {
      bookedby.staticData.storeGroupSettings.topBarNavigationContent = deparam(bookedby.staticData.storeGroupSettings.topBarNavigationContent || '');
    }

    if (this.modelNavigationModel) {
      this.navigationModel = new this.modelNavigationModel();
    }

    this.currentClient = new ClientModel({email: Cookies.get('lastLoginEmail')});
    this.currentClient.setPermissions(window.bookedby.staticData.permissions);
    this.currentClient.routePermissions = this.routePermissions;
    if(window.bookedby.staticData.client) {
      this.currentClient.logIn(window.bookedby.staticData);
      $.ajax({
        url: '/app/api/clients/checkPasswordExpiration',
        contentType: 'application/json',
        method: 'GET',
        success: function (result) {
          if (result.isPasswordExpired) {
            this.currentClient.logOut()
            bookedby.app.navigateWithNoAuth('login', {}, 'profile', {});
          }
        }.bind(this)
      });
    }

    this.viewManager = new this.viewManagerView();

    $('#main').html(this.viewManager.$el);

    this.initSpecific();

    this.currentPath = null;
    this.currentData = {};
    this.viewCache = {};
    this.initHistory();
    this.initContainerListener();
    // NOTE: Pass doNotTrack=true to skip tracking page_view twice (google analytics).
    // Moreover, this custom call of getCurrentState() before history is initialized
    // returns state with incorrect hash.
    this.onStateChanged(this.getCurrentState(), true);

    this.ignoreNextBooking = false;

    /**
     * log console.errors
     * based on: http://stackoverflow.com/questions/8000009/is-there-a-way-in-javascript-to-listen-console-events
     */
    var self = this;
    if (window && window.console && window.console.error) {
      var _nativeConsoleError = console.error;
      console.error = function() {
        self.logError(arguments[0]);
        return _nativeConsoleError.apply(console, arguments);
      }
    }
    cookieHelper.showOnloadNotification();

  },

  /**
   * Implementations should override this function with specific initializations for that
   * particular entry point
   */
  initSpecific: function() {},

  startLoading: function() {
    $('#loading').show();
  },

  finishLoading: function() {
    $('#loading').hide();
  },

  navigateTo: function(path, data) {
    data = data || {};
    var fullPath = path + "?" + $.param(data);
    this.beforeNavigate(path, data);
    this.doNavigate(fullPath);
  },

  navigateToNewTab: function(path, data) {
    data = data || {};
    var fullPath = path + "?" + $.param(data);
    this.beforeNavigate(path, data);
    this.doNavigateNewTab(fullPath);
  },

  navigateToIntended: function () {
    this.beforeNavigate(this.intended, this.intendedData);
    this.navigateTo(this.intended, this.intendedData);
  },

  navigateWithReplace: function(path, data) {
    data = data || {};
    var fullPath = path + "?" + $.param(data);
    this.beforeNavigate(path, data);
    this.doReplaceUrl(fullPath);
  },

  navigateWithNoAuth: function(toPath, toData, fromPath, fromData, silent) {
    this.hasIntendedNavigation = true;
    this.intended = fromPath == '' ? this.currentPath : fromPath;
    this.intendedData = fromData;

    // if the user logged out in another tab force that info into this session
    this.currentClient.logOut(Cookies.get('lastLoginEmail'));
    var toDataExtended = toData;

    if (!silent) {
      toDataExtended = _.extend(toData, {
        message: 'Please log in again in order to access the desired page'
      });
    }

    this.navigateWithReplace(toPath, toDataExtended);
  },

  navigateAfterAuthenticated: function(defaultPath, defaultData) {
    if (this.hasIntendedNavigation) {
      this.navigateToIntended();
      this.hasIntendedNavigation = false;
    } else {
      this.navigateTo(defaultPath, defaultData);
    }
  },

  getViewForPath: function(path) {
    if (!_.has(this.viewCache, path)) {
      this.viewCache[path] = (typeof this.routes[path] === 'string') ?
        this.getViewForPath(this.routes[path]) : new this.routes[path]();
    }
    return this.viewCache[path];
  },

  recentStateChangeTimes: [],

  onStateChanged: async function(newState, doNotTrack) {
    console.log(newState);

    //This stores timestamps when we have invoked onStateChanged
    this.recentStateChangeTimes.push(moment.utc());
    //Then we filter the list down to those instances that ocurred in the past 2 seconds
    this.recentStateChangeTimes = _.filter(this.recentStateChangeTimes, function (x) {
      return moment.utc().diff(x) < 2000;
    });

    //This is a brute-force protection against really misbehaving browser clients that are stuck in some sort of loop. This generally manifests as repeatedly calling onStateChanged and repeated loading of resources associated with the target page.
    if (this.recentStateChangeTimes.length > 14) {
      window.location.reload(true);
    }

    var urlFragment = newState.hash || '';
    //TODO:: this assumes that our entry-point is /main - either maintain that assumption or update this later
    var cleanFragment = urlFragment.replace(/^[^#]*#/, '');
    var parts = cleanFragment.split('?');
    var newPath = parts[0];
    if (parts[1]) {
      parts[1] = parts[1].replace(/&amp;/g, '&');
    }
    var newData;
    if (this.decodeStateData){
      newData = this.decodeStateData(parts[1] || '');
    }else{
      newData = querystring.decode(parts[1] || '');
    }
    var pathIsSame = (newPath === this.currentPath);

    if (pathIsSame && _.isEqual(newData, this.currentData)) {
      return;
    }

    //TODO Improve. This is just a quickfix, since some views expect a store param and others a storeId.
    if (newData.store != null || newData.storeId != null) {
      newData.store = newData.storeId = newData.store || newData.storeId;
    }

    if (newData.betaTest === '1') {
      bookedby.staticData.betaTest = true;
    }

    this.currentPath = newPath;
    this.currentData = newData;

    if (!_.has(this.routes, this.currentPath)) {
      if (this.currentPath != '') {
        console.log('Warning: unknown path: ' + this.currentPath);
      }
      this.navigateTo(this.defaultRoute);
      return;
    }

    if (this.checkRedirect) {
      this.checkRedirect = false;

      const shouldRedirectResponse = await fetch(
        bookedby.routes.AUTHENTICATION.SHOULD_REDIRECT + '/' + bookedby.staticData.storeGroupId + '?' + new URLSearchParams(
          { storeGroupId: bookedby.staticData.storeGroupId, storeId: newData.storeId }
        )
      );
      const shouldRedirect = (await shouldRedirectResponse.json()).shouldRedirect;

      if (shouldRedirect) {
        const query = new URLSearchParams(window.location.search);

        if (newData) {
          Object.entries(newData).forEach(([key, dataValue]) => {
            query.append(key, dataValue);
          })
        }

        query.append("page", newPath);
        query.append("storeGroupId", bookedby.staticData.storeGroupId);

        window.location = '/material-plus/' + bookedby.staticData.storeGroupId + '?' + query.toString();
        console.log('will redirect...');

        await new Promise(() => {}) // Never resolve. Blocking rendering.
      }
    }

    if (!this.currentClient.hasPermission(this.currentPath, this.currentData )) {
      this.intended = this.currentPath;
      this.intendedData = this.currentData;
      this.hasIntendedNavigation = false;
      this.navigateTo('login', {
        message: "You have no permission to access the page you were trying to access"
      });
      return;
    }

    // NOTE: Track event after all possible redirections are handled
    if (!doNotTrack) {
      this.trackGtagEvent(newState);
    }

    console.log('will render...');

    var newView = this.getViewForPath(this.currentPath);

    //setData of the view can return a promise that become resolved when all data is correctly set
    var setDataPromise;

    var allowLoadingNotification = newView.hasOwnProperty('isLoading');

    if (allowLoadingNotification){
      this.finishLoading(); //We don`t need generic loading spinner then
      newView.isLoading = true;
    }

    if ((newPath == 'booking' || newPath == 'booking-confirmation') && this.ignoreNextBooking) {
      this.ignoreNextBooking = false;

      if (bookedby.app.viewCache['single-store-search'] != null) {
        delete bookedby.app.viewCache['single-store-search'];
      }

      if (bookedby.app.viewCache['single-store-first-search'] != null) {
        delete bookedby.app.viewCache['single-store-first-search'];
      }

      if (bookedby.app.viewCache['booking-process'] != null) {
        delete bookedby.app.viewCache['booking-process'];
      }

      if (bookedby.app.viewCache['start-booking'] != null) {
        delete bookedby.app.viewCache['start-booking'];
      }

      bookedby.app.navigateWithReplace('start-booking', {});
      return;
    }

    if (typeof newView.setData === 'function') {
      setDataPromise = newView.setData(this.currentData, this.currentPath);
    } else {
      console.log('Warning: view does not have setData function, for path: ' + this.currentPath);
    }

    if (this.navigationModel) {
      this.navigationModel.set('currentTab', this.currentPath);
    }

    function _initAndRenderView(viewManager, view, data, path){
      if (view.initEvents)
        view.initEvents(data, path);
      viewManager.setCurrentPage(view);
      viewManager.render();
      if (allowLoadingNotification){
        view.isLoading = false;
      }
    }

    if (!pathIsSame) {
      if (setDataPromise && setDataPromise.then){
        setDataPromise.then(_.bind(function(){
          _initAndRenderView( this.viewManager, newView, this.currentData, this.currentPath);
        }, this));
      } else {
        _initAndRenderView( this.viewManager, newView, this.currentData, this.currentPath);
      }

      if (!this.pageRendered) {
        this.pageRendered = true;
        $('#main').show();
      }
    }
  },

  //Temporary - replace with calls to frame
  doNavigate: function(fragment) {
    if ('parentIFrame' in window) {
      window.parentIFrame.sendMessage({
        action: 'navigate',
        data: fragment
      });
    } else {
      History.pushState(null, null, fragment);
    }

  },

  doNavigateNewTab: function(fragment) {
    if ('parentIFrame' in window) {
      window.parentIFrame.sendMessage({
        action: 'new-tab',
        data: fragment
      });
    } else {
      History.pushState(null, null, fragment);
    }

  },

  //Temporary - replace with calls to frame
  doReplaceUrl: function(fragment) {
    if ('parentIFrame' in window) {
      window.parentIFrame.sendMessage({
        action: 'replace',
        data: fragment
      });
    } else {
      History.replaceState(null, null, fragment);
    }
  },

  //This is temporary - will be replaced once XDM iframe communication is ironed out
  initHistory: function() {
    if ('parentIFrame' in window) {

    } else {
      History.Adapter.bind(window, 'statechange', _.bind(function() {
        var state =  History.getState();
        this.onStateChanged(state);
        this.setDocumentTitle();
      }, this));
    }
  },

  initContainerListener: function() {
    window.iFrameResizer = {
      messageCallback: _.bind(function(container) {
        if (container.action == 'navigate') {
          var state = container.state;
          this.onStateChanged(state);
        }
      }, this)
    }
  },

  setDocumentTitle: function () {
    var add = getAdditionForTitle();
    $("#ui-datepicker-div").css("display", "none");
    $("#logoImage").attr("alt", "Sport Clips Haircuts");
    document.title = bookedby.staticData.storeGroupSettings.storeGroupWebPageTitle + add;
  },

  //Temporary - replace with calls to frame
  getCurrentState: function() {
    if ('parentIFrame' in window) {
      return window.parent.History.getState();
    } else {
      return History.getState();
    }

  },

  /**
   * @override
   */
  navigateToLogin: function() {},

  /**
   * Global logout function.  Calls the backend to destroy the session.
   */
  logOut: function() {
    $.ajax({
      url: '/app/api/clients/logout',
      contentType: 'application/json',
      method: 'POST',
      success: function (result) {
        this.currentClient.logOut(Cookies.get('lastLoginEmail'));
        this.onLoggedInChange();
        bookedby.app.navigateToLogin();
      }.bind(this)
    });
  },

  logoutHard: function() {
    $.ajax({
      url: '/app/api/clients/logout',
      contentType: 'application/json',
      method: 'POST',
      success: function (result) {
        this.currentClient.logOut();
        this.onLoggedInChange();
        window.location.reload();
      }.bind(this)
    });
  },

  /**
   * This probably shouldn't be here.  Probably belongs in a service class.  Currently is actually handled in the modal
   */
  loginClient: function(email, password, successCallback, errorCallback) {
    $.ajax({
      url: bookedby.routes.AUTHENTICATION.DO_LOGIN,
      contentType: 'application/json',
      data: JSON.stringify({ email: email, password: password, section: this.section, storeGroupUuid: bookedby.staticData.storeGroupId}),
      method: 'POST',
      dataType: 'json',
      success: _.bind(function(data) {
        if (data.success && data.found) {
          if (data.isPasswordExpired) {
            bookedby.app.showChangePassword({ successCallback: successCallback , errorCallback: errorCallback});
          } else {
            this.onLoginResponse(data);
            if (typeof successCallback === 'function') {
              successCallback(data);
            }
          }
        } else {
          if (typeof errorCallback === 'function') {
            errorCallback(data);
          }
        }
      }, this),
      error: _.bind(function(jqXHR, textStatus, textError) {
        console.log('Error: ' + textError);
        //TODO:: anything?
        if (typeof errorCallback === 'function') {
          errorCallback({
            success: false,
            userError: false,
            error: textError
          });
        }
      }, this)
    })
  },

  onLoginResponse: function(data) {
    var client = this.setLoggedCurrentClient(data);
    this.onLoggedInChange();
    return client;
  },

  setLoggedCurrentClient: function(data) {
    Cookies.set('lastLoginEmail', data.client.email, { expires: 365 * 10 }); // 10 years
    this.currentClient.logIn(data);
    return this.currentClient;
  },

  /**
   * Rerender the UI when the login changes.
   */
  onLoggedInChange: function() {
    var currentView = this.getViewForPath(this.currentPath);
    if (typeof currentView.refresh === 'function') {
      currentView.refresh();
    } else {
      currentView.render();
    }
  },

  //The contents of this are passed to all templates in the "user" variable
  getCurrentClient: function() {
    return this.currentClient;
  },

  checkCurrentClient: function(onSuccess, client, onNotFound) {
    var clientModel = client || this.currentClient;
    if (clientModel != null && (clientModel.get('email') != null && clientModel.get('email').length > 6)
      || (clientModel.get('firstName') != null && clientModel.get('lastName') != null && clientModel.get('phone') != null)) {
      $.ajax({
        url: bookedby.routes.AUTHENTICATION.CHECK_USER,
        method: "POST",
        data: JSON.stringify({
          client: clientModel,
          storeGroupUuid: bookedby.staticData.storeGroupId
        }),
        contentType: "application/json",
        success: function(data) {
          if(data.success && data.found) {
            if(data.email != clientModel.get('email')) {
              clientModel.set('validationSuspended', true);
              clientModel.set('email', data.email);
              clientModel.set('validationSuspended', false);
            }
            onSuccess(data);
          } else if (data.success && !data.found) {
            onNotFound();
          }
        }.bind(this)
      });
    }
  },

  sendConfirmation: function(confirmationType, clientData, checkInData, waitTimeData) {
    data = {
      storeGroupUuid: bookedby.staticData.storeGroupId,
      confirmationType: confirmationType,
      client: clientData,
      storeId: (bookedby.app.lastSelectedStore == null) ? null : bookedby.app.lastSelectedStore.id
    }
    if (checkInData && waitTimeData){
      data.checkInData = checkInData;
      data.checkInWait = waitTimeData;
    }
    return $.ajax({
      url: bookedby.routes.AUTHENTICATION.SEND_CONFIRMATION_CODE,
      method: "POST",
      headers: {
        'X-Is-OLCI-Web': '1'
      },
      data: JSON.stringify(data),
      contentType: "application/json",
    });
  },

  checkConfirmation: function(email, phone, type, name, confirmationToken) {
    return $.ajax({
      url: bookedby.routes.AUTHENTICATION.CHECK_CONFIRMATION_CODE,
      method: "POST",
      data: JSON.stringify({
        email: email,
        phone: phone,
        type: type,
        token: confirmationToken
      }),
      contentType: "application/json",
    })
  },

  getCurrentClientJson: function() {
    return this.getCurrentClient().toJSON();
  },

  /**
   * Override with a function that will be called on every navigation
   */
  beforeNavigate: function() {},

  /**
   *
   * @param {string} message
   * @param {object} params. Should contain a 'url' property and optional data object with params'
   */
  logAPIError: function(message, params) {
    var completeMessage = 'API Error: ' + message + ' (path: ' + window.location.hash +  ')';
    if (window.appInsights != null) {
      let props = {};
      if (params) {
        props.url = params.url;
        _.each(params.data, function(value, key) {
          props[key] = value;
        })
      }
      window.appInsights.trackException({
        exception: new Error(completeMessage),
        properties: props
      });
    }

    if (window.Muscula != null) {
      if (params) {
        Muscula.info = ['api: ' + params.url];
        _.each(params.data, function(value, key) {
          Muscula.info.push(key + ': ' + value);
        })
      } else {
        Muscula.info = [];
      }
      Muscula.errors.push(new Error('API Error: ' + message));
    }

    console.log('Logging API Error: ' + message);
  },

  logError: function(message) {
    var completeMessage = message + ' (path: ' + window.location.hash +  ')';
    if (window.appInsights != null) {
      window.appInsights.trackException({
        exception: new Error(completeMessage),
        properties: { path: this.currentPath }
      });
    }

    if (window.Muscula != null) {
      Muscula.info = [];
      Muscula.errors.push(new Error(message));
    }

    console.log('Logging Error: ' + message);
  },

  checkClientIsRegistered: function(callback, client) {
    var clientModel = client || bookedby.app.getCurrentClient();

    $.ajax({
      url: bookedby.routes.AUTHENTICATION.CHECK_IS_REGISTERED,
      method: 'POST',
      data: JSON.stringify({
        client: clientModel
      }, function (key, value) {
        if (key == 'birthday') {
          return clientModel.getBirthdayStoringFormat();
        } else {
          return value;
        }
      }),
      cache: false,
      contentType: 'application/json',
      success: _.bind(function(data) {
        if (typeof callback === 'function') {
          callback(data, clientModel);
        }
      }, this),
      error: _.bind(function(jqXHR, textStatus, textError) {
        console.log('Error: ' + textError);
        if (typeof callback === 'function') {
          callback({
            success: false,
            userError: false,
            error: textError
          });
        }
      }, this)
    });
  },

  registerAndCheckin: function(confirmationCode, password, passwordConfirmation, hasCheckIn){
    var dfd = $.Deferred();
    $.ajax({
      url: bookedby.routes.AUTHENTICATION.REGISTER_AND_CHECKIN,
      method: "POST",
      data: JSON.stringify({
        "code": confirmationCode,
        "password": password,
        "confirmPassword": passwordConfirmation,
        "mobile": false,
        "tryCheckIn": hasCheckIn
      }),
      cache: false,
      contentType: "application/json",
      success: _.bind(function(data) {
        if (data.success) {
          dfd.resolve({loggedInClient: this.setLoggedCurrentClient({ client: data.registerResult }), checkInData: data.checkInData, checkInResult: data.checkInResult});
        } else {
          dfd.reject(data);
        }
      }, this),
      error: function(jqXHR, textStatus, textError) {
        console.log('Error: ' + textError);
        //TODO:: anything?
        dfd.reject({
          success: false,
          userError: false,
          error: textError
        });
      }
    });
    return dfd.promise();
  },

  trackGtagEvent: function(newState) {
   function ensureLeadingSlash(url) {
      if (!url || url.length === 0) {
        return "/";
      } else if (url[0] !== "/") {
        return "/" + url;
      } else {
        return url;
      }
    }
    //If the google analytics id is missing, don't do anything
    if (typeof gtag == 'undefined' || window.GA_TRACKING_ID == null)
      return;

    gtag('js', new Date());
    // NOTE: It would be better to use newState.url as page_location but due to buggy
    // behavior of history.js it contains incorrect url.
    // Additionaly, history.js seems to be dead (~5 years from the last release) so instead of
    // trying to fix it might be reasonable to replace it
    gtag('config', window.GA_TRACKING_ID, {
      'page_title': newState.title,
      'page_location': History.getLocationHref(),
      'page_path': ensureLeadingSlash(newState.hash)
    });
  },

  updateCurrentClientMarketingOptIn: function(optInFlag, storeId) {
    var dfd = $.Deferred();
    $.ajax({
      url: bookedby.routes.CLIENT.MARKET_OPT_IN_UPDATE,
      method: "POST",
      cache: false,
      data: JSON.stringify({
        smsMarketingOptIn: optInFlag,
        storeId: storeId,
        storeGroupUuid: bookedby.staticData.storeGroupId
      }),
      contentType: "application/json",
      success: _.bind(function(responseData) {
        if (!responseData.success) {
          this.logAPIError(responseData.error);
          dfd.reject(responseData);
        } else {
          var currentClient = this.getCurrentClient();
          //update local client info
          currentClient.set("smsMarketingOptIn", optInFlag);
          dfd.resolve();
        }
      }, this),
      error: _.bind(function(jqXHR, textStatus, textError) {
        this.logAPIError(textError);
        dfd.reject({userError: textError})
      }, this)
    });
    return dfd.promise();
  },

  updateCurrentClientOptIn: function(optInFlag) {
    var dfd = $.Deferred();
    $.ajax({
      url: bookedby.routes.CLIENT.OPT_IN_UPDATE,
      method: "POST",
      cache: false,
      data: JSON.stringify({
        smsOptIn: optInFlag
      }),
      contentType: "application/json",
      success: _.bind(function(responseData) {
        if (!responseData.success) {
          this.logAPIError(responseData.error);
          dfd.reject(responseData);
        } else {
          var currentClient = this.getCurrentClient();
          //update local client info
          currentClient.set("smsOptIn", optInFlag);
          dfd.resolve();
        }
      }, this),
      error: _.bind(function(jqXHR, textStatus, textError) {
        this.logAPIError(textError);
        dfd.reject({userError: textError})
      }, this)
    });
    return dfd.promise();
  },

  updateCurrentClientProfile: function(changedClientModel) {
    var dfd = $.Deferred();
    $.ajax({
      url: bookedby.routes.CLIENT.PROFILE_UPDATE,
      method: "POST",
      cache: false,
      data: JSON.stringify({
        firstName: changedClientModel.get("firstName"),
        lastName: changedClientModel.get("lastName"),
        phone: changedClientModel.get("phone"),
        email: changedClientModel.get("email"),
        gender: changedClientModel.get("gender"),
        birthday: changedClientModel.get("birthday") ? moment(changedClientModel.get("birthday"), 'MM-DD-YYYY').format('YYYY-MM-DD') : null,
        zipCode: changedClientModel.get("zipCode"),
        confirmationType: changedClientModel.get("confirmationType"),
        smsOptIn: changedClientModel.get('smsOptIn'),
        smsMarketingOptIn: changedClientModel.get('smsMarketingOptIn'),
        storeGroupUuid: bookedby.staticData.storeGroupId
      }),
      contentType: "application/json",
      success: _.bind(function(responseData) {
        if (!responseData.success) {
          this.logAPIError(responseData.error);
          dfd.reject(responseData);
        } else {
          var currentClient = this.getCurrentClient();
          //update local client info
          currentClient.logIn({client: responseData});
          currentClient.set("updatedSuccess", true);
          this.onLoggedInChange();
          dfd.resolve(currentClient);
        }
      }, this),
      error: _.bind(function(jqXHR, textStatus, textError) {
        this.logAPIError(textError);
        dfd.reject({userError: textError})
      }, this)
    });
    return dfd.promise();
  }
};

module.exports = App;
